import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'

export const LabelAssetLinkItemSchema = buildEntrySchemaFor('labelAssetLinkItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      heading: RichTextSchema,
      description: RichTextSchema,
      href: z.string(),
      label: z.string(),
      eyebrow: z.string().optional(),
      assetType: z.enum(['Image', 'Video']).optional(),
      optionImage: AssetSchema.optional(),
      optionVideo: AssetSchema.optional(),
      optionPoster: AssetSchema.optional(),
    }),
  ),
})
export type LabelAssetLinkItem = z.infer<typeof LabelAssetLinkItemSchema>
